import { BlockchainID, IGetWhitelistParamsResponse } from 'multirpc-sdk';
import { Chain } from '@ankr.com/chains-list';

import { JWT } from 'domains/jwtToken/types';

export enum NewProjectStep {
  General,
  Chains,
  Whitelist,
}

type ProjectChainsType = Chain & {
  beaconsMainnet?: Chain[];
  beaconsTestnet?: Chain[];
  opnodesMainnet?: Chain[];
  opnodesTestnet?: Chain[];
};

export type ProjectChain = ProjectChainsType & {
  mainnets?: Chain[];
};

export interface IProjectWithBlockchains
  extends Pick<JWT, 'index' | 'name' | 'userEndpointToken'> {
  blockchains: BlockchainID[];
}

export interface IProjectWithWitelists
  extends Pick<JWT, 'index' | 'name' | 'userEndpointToken'> {
  whitelists: IGetWhitelistParamsResponse;
}
